<span class="badge {{ classNames }}">{{ displayText }}</span>
